const global_accounts = {1: 'Coach Account', 2: 'Assitant Coach Account', 3: 'Member Account', 4 : 'Customer Account'};
let globalcUserid = 0;
let globalcUsername = 0;
let globalcUseremail = "";
let globalcShopifyid = 0;
let globalcRoleid = 0;
let globalcTeamid = 0;
let globalcTeamname = "";
let globalcTeamurl = "";
let globalcTeamShurl = "";
let globalcTowenerid = 0;
let globalcTowener = "";

function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

function onteamChange(teamoption) {
    //var selectedOptionUrl = document.getElementById('team-select').options[document.getElementById('team-select').selectedIndex].getAttribute('data-url');
    var selectedOptionUrl = teamoption.getAttribute('data-url');
    //var selectedTeamName = document.getElementById('team-select').options[document.getElementById('team-select').selectedIndex].getAttribute('data-name');
    var selectedTeamName = teamoption.getAttribute('data-name');
    selectedTeamName = selectedTeamName.replace(/\s+/g, '-').toLowerCase();
    var steamlink = document.getElementById('teamlink');
    if(steamlink != null) steamlink.value = selectedOptionUrl;
    //var selectedopt = document.getElementById('team-select');
    //var selectedteamid = selectedopt.value;
    var selectedteamid = teamoption.getAttribute('data-value');
    //console.log(selectedteamid+": "+selectedTeamName);
    //return false;
    setCookie('sf_teamid', selectedteamid, 7);
    setCookie('sf_teamnameurl', selectedTeamName, 7);
    
    const currentpagename = getPageName();
    if ( currentpagename === 'account-orderdetail') {
        window.location.href = '/account';
    }else {
        location.reload();
    }
    //document.getElementById('teamlink').innerText = selectedOptionUrl    
    //document.getElementById('teamlink').innerText = teamoption.options[event.target.selectedIndex].dataset.url;
}

function setCookie(cName, cValue, expDays) {
        let date = new Date();
        date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
}

function getCookie(cName) {
    const name = cName + "=";
    const cDecoded = decodeURIComponent(document.cookie); //to be careful
    const cArr = cDecoded .split('; ');
    let res;
    cArr.forEach(val => {
        if (val.indexOf(name) === 0) res = val.substring(name.length);
    })
    return res;
}

function getPageName() {
    const urlString = window.location.pathname;
    const urlWithoutTrailingSlash = urlString.replace(/\/$/, '');
    const segments = urlWithoutTrailingSlash.split('/');
    const lastSegment = segments[segments.length - 1];
    return lastSegment;
}

function goblePopupModel(divid, gtitle, gbody){
    var ghtml = `<div id="goblePopupModel" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" id="goblePopupModelclose">&times;</button>
                        <h4 class="modal-title" style="text-align:center;">`+gtitle+`</h4>
                    </div>
                    <div class="modal-body">`+gbody+`</div>
                </div>
            </div>
        </div>`;
    var pdiv = document.getElementById(divid);
    pdiv.innerHTML = ghtml;
    var model = document.getElementById('goblePopupModel');
    var modelclose = document.getElementById('goblePopupModelclose');
    model.style.display = 'block';
    modelclose.addEventListener("click",function(e){
        //model.style.display = 'none';
        pdiv.innerHTML = "";
    });
}